
define(
	'Code25.CaterpartsGlobal.SalesRep'
	, [
		"Utils"
	]
	, function (
		Utils
	) {
		'use strict';
		return {
			mount: function mount(container) {

				var QuoteToSalesOrderWizardStep = require("QuoteToSalesOrderWizard.Step");
				if (QuoteToSalesOrderWizardStep) {
					if (QuoteToSalesOrderWizardStep.QuoteToSalesOrderWizardStep) {
						QuoteToSalesOrderWizardStep = QuoteToSalesOrderWizardStep.QuoteToSalesOrderWizardStep;
					}
					_.extend(QuoteToSalesOrderWizardStep.prototype, {

						getContext: _.wrap(QuoteToSalesOrderWizardStep.prototype.getContext, function (getContext) {
							var res = getContext.apply(this, _.rest(arguments));
							res.salesrepName="Sales";
							res.salesrepEmail="sales@caterparts.com";
							return res;

						})
					});
				}

				var QuoteDetailsView = require("Quote.Details.View");
				if (QuoteDetailsView) {
					if (QuoteDetailsView.QuoteDetailsView) {
						QuoteDetailsView = QuoteDetailsView.QuoteDetailsView;
					}
					_.extend(QuoteDetailsView.prototype, {

						getContext: _.wrap(QuoteDetailsView.prototype.getContext, function (getContext) {
							var res = getContext.apply(this, _.rest(arguments));
							res.salesrepName="Sales";
							res.salesrepEmail="sales@caterparts.com";
							return res;

						})
					});
				}

			}

		}

	});
